export default "__VITE_ASSET__BBUACftF__"